

import React, { useState } from 'react';
import Header from './Header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from 'react-router-dom';
import Footer2 from './Footer2';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import GoogleBtn from './GoogleBtn';
const Ragister = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        First_Name: '',
        Last_Name: '',
        Email: '',
        Password: ''
    });
    const handleGoogleDataFetch = (userData) => {
        // console.log("📥 Fetched from Google:", userData);

        // ✅ formData update 
        setFormData(prev => ({
            ...prev,
            First_Name: userData.firstName,
            Last_Name: userData.lastName,
            Email: userData.email
        }));

        toast.success("Details fetched from Google! Please enter password.");
    };

    // const handleChange = (e) => {
    //     const { id, value } = e.target;
    //     setFormData(prev => ({
    //         ...prev,
    //         [id]: value
    //     }));
    // };
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: id === 'Email' ? value.toLowerCase() : value
        }));
    };
    const handleSubmit = async () => {

        // ✅ Check 1: Empty fields
        if (!formData.First_Name.trim()) {
            toast.error("Please enter First Name");
            return;
        }
        if (!formData.Last_Name.trim()) {
            toast.error("Please enter Last Name");
            return;
        }
        if (!formData.Email.trim()) {
            toast.error("Please enter Email");
            return;
        }

        // ✅ Check 2: Email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.Email.trim())) {
            toast.error("Please enter a valid email address");
            return;
        }

        // ✅ Check 3: Real email domain only
        const emailDomain = formData.Email.split('@')[1]?.toLowerCase();
        const validDomains = [
            'gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com',
            'icloud.com', 'protonmail.com', 'rediffmail.com', 'live.com',
            'ymail.com', 'zoho.com', 'aol.com', 'msn.com'
        ];
        if (!validDomains.includes(emailDomain)) {
            toast.error("Please use a valid email (Gmail, Yahoo, Outlook etc.)");
            return;
        }

        if (!formData.Password.trim()) {
            toast.error("Please enter Password");
            return;
        }

        // ✅ Check 4: Password min 6 chars + uppercase + number + special char
        if (formData.Password.trim().length < 6) {
            toast.error("Password must be at least 6 characters");
            return;
        }
        if (!/[A-Z]/.test(formData.Password)) {
            toast.error("Password must contain at least 1 uppercase letter (A-Z)");
            return;
        }
        if (!/[0-9]/.test(formData.Password)) {
            toast.error("Password must contain at least 1 number (0-9)");
            return;
        }
        if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(formData.Password)) {
            toast.error("Password must contain at least 1 special character (!@#$...)");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_SECRET_KEY}/api/userregister`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            // ✅ Check 5: Duplicate email - backend message
            if (result.message === "Email already registered") {
                toast.error("This email is already registered. Please use a different email.");
                return;
            }

            // ✅ Check 6: Invalid domain - backend message
            if (result.message === "Please use a valid email provider (Gmail, Yahoo, Outlook etc.)") {
                toast.error(result.message);
                return;
            }

            if (response.ok) {
                toast.success("Registration successful!");
                // console.log(result);
                setFormData({
                    First_Name: '',
                    Last_Name: '',
                    Email: '',
                    Password: ''
                });
                setTimeout(() => {
                    navigate('/login');
                }, 1500);
            } else {
                toast.error(result.message || "Registration failed.");
            }

        } catch (error) {
            // console.error("Error:", error);
            toast.error("Something went wrong.");
        }
    };

    return (
        <>
            <Header />
            <ToastContainer />
            {/* Hide browser default eye icon */}
            <style>{`
                input[type="password"]::-ms-reveal,
                input[type="password"]::-ms-clear,
                input::-webkit-credentials-auto-fill-button,
                input::-webkit-textfield-decoration-container {
                    display: none !important;
                }
            `}</style>
            <div className="login-main">
                <div className="container">
                    <div className="login-inner-main">
                        <div className="login-child">
                            <h2 className="login-title">Create Account</h2>

                            <div className="login-inner-child">
                                <GoogleBtn onDataFetch={handleGoogleDataFetch} />

                                {/* ✅ OR Divider */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: '20px 0'

                                }}>
                                    <div style={{ flex: 1, borderBottom: '1px solid #ddd' }}></div>
                                    <span style={{ padding: '0 10px', color: '#999', fontSize: '14px' }}>OR</span>
                                    <div style={{ flex: 1, borderBottom: '1px solid #ddd' }}></div>
                                </div>
                                <label htmlFor="First_Name">FIRST NAME</label>
                                <input
                                    type="text"
                                    id="First_Name"
                                    className="login-input"
                                    value={formData.First_Name}
                                    onChange={handleChange}
                                />

                                <label htmlFor="Last_Name">LAST NAME</label>
                                <input
                                    type="text"
                                    id="Last_Name"
                                    className="login-input"
                                    value={formData.Last_Name}
                                    onChange={handleChange}
                                />

                                <label htmlFor="Email">E-MAIL</label>
                                <input
                                    type="email"
                                    id="Email"
                                    className="login-input"
                                    value={formData.Email}
                                    onChange={handleChange}
                                />

                                <label htmlFor="Password">PASSWORD</label>
                                <div className="password-wrapper" style={{ position: 'relative', width: '100%' }}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="Password"
                                        className="login-input"
                                        value={formData.Password}
                                        onChange={handleChange}
                                    />
                                    <span
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{
                                            position: 'absolute',
                                            right: '0',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            fontSize: '18px',
                                            color: '#5a5a5a',
                                            paddingRight: '10px'
                                        }}
                                    >
                                        {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                                    </span>
                                </div>
                                <button className="login-button" onClick={handleSubmit}>CREATE</button>
                                <p className="create-account">
                                    Already have an account? <Link to='/login'>Login</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer2 />
        </>
    );
};

export default Ragister;